/** 匹配等待「茶余小憩」用的成语雅故。短句以便四行内读完。 */
export const IDIOM_ANECDOTES: readonly [string, string][] = [
  ["胸有成竹", "苏轼记文与可画竹：画竹必先得成竹于胸中。比喻事先已有成算。"],
  ["抛砖引玉", "相传常建作诗未完，欲引赵嘏佳句。后指先出浅见，以求引出高明。"],
  ["旗鼓相当", "古时两军对阵，旗帜与战鼓相齐。比喻双方实力差不多。"],
  ["破釜沉舟", "项羽渡河后砸锅沉船，不留退路，巨鹿一战大破秦军。"],
  ["卧薪尝胆", "越王勾践睡柴薪、尝苦胆，不忘会稽之耻，十年生聚，终灭吴国。"],
  ["三顾茅庐", "刘备三次拜访隆中诸葛亮，才请出卧龙出山，共图大业。"],
  ["望梅止渴", "曹操行军无水，扬言前有梅林，士卒生津，才赶到水源。"],
  ["画蛇添足", "楚人酒令画蛇，有人画完又添足，反失去饮酒资格。"],
  ["滥竽充数", "南郭处士不会吹竽，混在齐宣王三百人乐队里吃粮。"],
  ["守株待兔", "宋人见兔撞树桩而死，便放下农具守株，再无所获。"],
  ["刻舟求剑", "楚人渡江剑落，在船舷刻记，靠岸仍从刻痕处下水去找。"],
  ["亡羊补牢", "羊丢了再修圈，犹未为晚。《战国策》劝人及时补救。"],
  ["纸上谈兵", "赵括熟读兵书却无实战，长平之战大败，赵军四十万被坑。"],
  ["完璧归赵", "蔺相如奉璧入秦，见秦王无意偿城，设计将和氏璧送回赵国。"],
  ["负荆请罪", "廉颇不服蔺相如位居其上，后负荆请罪，将相和好。"],
  ["围魏救赵", "孙膑围攻魏都大梁，迫使魏军回救，桂陵一战解赵之围。"],
  ["草木皆兵", "淝水之战，前秦军心已乱，见八公山草木都疑是晋兵。"],
  ["四面楚歌", "项羽被汉军围于垓下，夜闻四面皆楚歌，以为楚地尽失。"],
  ["一鸣惊人", "楚庄王三年不飞不鸣，一飞冲天、一鸣惊人，而后称霸。"],
  ["闻鸡起舞", "祖逖与刘琨闻鸡鸣即起舞剑，互相激励，立志报国。"],
  ["凿壁偷光", "匡衡家贫无烛，凿开墙壁借邻家灯光读书，终成经学家。"],
  ["程门立雪", "杨时求教程颐，适逢先生午睡，侍立门外至雪深一尺。"],
  ["刮目相看", "吕蒙受孙权劝学，鲁肃再见时说士别三日，当刮目相待。"],
  ["乐不思蜀", "刘禅降魏后被问想不想蜀，答此间乐，不思蜀。"],
  ["指鹿为马", "赵高献鹿却称是马，群臣有附和者，借此清除异己。"],
  ["狐假虎威", "狐狸走在老虎前面，百兽惊逃。比喻依仗别人的威势吓人。"],
  ["塞翁失马", "边塞老人失马又得马，祸福相倚。语出《淮南子》。"],
  ["杯弓蛇影", "壁上弓影映在酒杯里，有人疑是蛇，忧惧成疾。"],
  ["愚公移山", "北山愚公率子孙挖太行、王屋，帝感其诚，命神把山移走。"],
  ["朝三暮四", "狙公喂猴，朝三暮四与朝四暮三实质一样，猴子却喜怒不同。"],
  ["井底之蛙", "井蛙对海鳖夸井中之乐，不知有海。比喻见识短浅。"],
  ["对牛弹琴", "公明仪对牛弹琴，牛只顾吃草。后指说话不看对象。"],
  ["掩耳盗铃", "有人捂住自己耳朵去偷铃，以为自己听不见别人也听不见。"],
  ["鞠躬尽瘁", "诸葛亮《出师表》：鞠躬尽瘁，死而后已。后指尽心竭力。"],
  ["东山再起", "谢安一度隐居东山，后复出执政，成为东晋重臣。"],
  ["精卫填海", "炎帝之女女娃溺于东海，化为精卫，衔石填海，志在复仇。"],
  ["盲人摸象", "几个盲人摸象，各执一端，都以为自己摸到了全貌。"],
  ["破镜重圆", "乐昌公主与徐德言破镜各执一半，乱后续缘，终得团圆。"],
  ["囊萤映雪", "车胤夏夜囊萤、孙康冬夜映雪，借微光苦读，后皆有成。"],
  ["金玉其外", "刘基写卖柑者：金玉其外，败絮其中。后讽虚有其表。"],
];
